import { factoryReducer, flattenStringMap } from '../../../../reducers/utils'

import { actionTypes } from './constants'
import { reducer, actionTypes as LKGridInstanceActionTypes } from '../LKGridInstance'

export default factoryReducer(
  {
    registerType: actionTypes.regUnreg.REGISTER_INSTANCE,
    unregisterType: actionTypes.regUnreg.UNREGISTER_INSTANCE,
  },
  flattenStringMap(LKGridInstanceActionTypes),
  reducer,
  (meta) => meta.instanceName,
)
